import React from "react";

function ScheduleCallIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      width="20"
      height="20"      
      className="call-icon"
      enableBackground="new 0 0 100 100"
      version="1.1"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
    >
      <path
        fill="#fff"
        d="M88.9 0H11C4.9 0 0 4.9 0 11v78c0 6 4.9 11 11 11h78c6 0 11-4.9 11-11V11c-.1-6.1-5-11-11.1-11zm-9.8 74.5c-5.9 7-14.5 5.1-14.5 5.1-12.4-1.8-23.4-11.4-23.4-11.4-20.5-17.9-20.8-29.8-20.8-29.8-2.5-11.2 5.4-17.9 5.4-17.9 3.3-2.8 6.6-.6 6.6-.6l9.3 9.2c4.2 4.2-.1 7.9-.1 7.9L39 39.7c-1 1-1.2 2.5-.6 3.7 5 9.3 14 15.7 18 18.2 1.2.8 2.8.6 3.9-.5l3.9-3.7c3.6-2.3 5.9.3 5.9.3l9.3 9.2c3.8 4.6-.3 7.6-.3 7.6z"
        className="st0"
      ></path>
    </svg>
  );
}

export default ScheduleCallIcon;